// componente che contiene tutti i metodi utilizzati per gestire i pannelli; queste funzioni sono richiamate esternamente
// dalle altre componenti che costituiscono tutto il blocco di gestione pannelli (groups-edit e groups-list)

import { Injectable } from '@angular/core';
import { Groups } from './groups.model';
import { Subject } from 'rxjs';

@Injectable()
export class GroupsService {
  private groups: Groups[] = [];
  groupsChanged = new Subject<Groups[]>();
  groupsEditMode = new Subject<number>();

  constructor(
  ) { }

  // metodo richiamato alla modifica di un pannello; viene identificata la posizione nella tabella dell'elemento da aggiornare
  editGroups(groupsId: number) {
    this.groupsEditMode.next(groupsId);
  }

  // metodo richiamato all'inserimento di un nuovo pannello; viene identificata la posizione nella tabella dell'elemento da aggiungere
  setGroups(groups: Groups[]) {
    if (groups !== null) {
      this.groups = groups;
      this.groupsChanged.next(this.groups.slice());
    }
  }

  // metodo che restituisce l'intero oggetto "pannello" in base alla posizione nella tabella
  getGroupsByIndex(id: number) {
    return this.groups.find(x => x.id === id);
  }

  // metodo che restituisce tutti i pannelli memorizzati localmente
  getGroups() {
    return this.groups;
  }

  // metodo che inserisce il nuovo pannello appena inserito nell'array locale contenente tutti i pannelli, aggiornando la tabella
  addGroups(groups: Groups) {
    groups.id = this.groups.length;
    this.groups.push(groups);
    this.groupsChanged.next(this.groups.slice());
  }

  // metodo che aggiorna il pannello appena modificato nell'array locale contenente tutti i pannelli, aggiornando la tabella
  updateGroups(index: number, groups: Groups) {
    this.groups[index] = groups;
    this.groupsChanged.next(this.groups.slice());
  }

  // metodo che individua la posizione del pannello appena cancellato, aggiorna la tabella e l'array locale contenente tutti i pannelli
  deleteGroups(id) {
    var elementPos = this.groups.map(function (x) { return x.id; }).indexOf(id);
    this.groups.splice(elementPos, 1);
    this.groupsChanged.next(this.groups.slice());
  }
}
